<template>
  <div id="accounts-table">
    <v-data-table
      :items="data"
      :headers="headers"
      :loading="isLoading"
      class="body-2 elevation-2"
      :options.sync="pagination"
      :footer-props="footerProps"
      :items-per-page="paginationMeta.itemsPerPage"
      :no-data-text="$dictionary.app.common.accounts.noData"
      :server-items-length="paginationMeta.serverItemsLength"
      :loading-text="$dictionary.app.common.accounts.loading"
    >
      <template #item.name="{item}">
        <table-matrics-row
          is-link
          is-text-pointer
          :text="item.name"
          text-class="blue--text"
          :query="{ active_tab: 'profile' }"
          :navigate-to="`${$paths.accounts}/${item.id}`"
        />
      </template>

      <template #item.status="{item}">
        <status-chip :text="item.status" />
      </template>

      <template #item.customer_name="{item}">
        <table-matrics-row
          is-link
          is-text-pointer
          text-class="blue--text"
          :text="item.customer_name"
          :query="{ active_tab: 'customer_details' }"
          :navigate-to="`${$paths.customers}/${item.customer_id}/customer`"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { PaginationSortMixin } from "@/mixins";
import headers from "@/data/table-headers/accounts-index.headers.json";
import TableMatricsRow from "../shared/TableMatricsRow.vue";
import StatusChip from "../shared/StatusChip.vue";

/**
 * Accounts table
 */
export default {
  name: "AccountsTable",
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: { StatusChip, TableMatricsRow },
  /**
  |--------------------------------------------------
  | Mixins
  |--------------------------------------------------
  */
  mixins: [PaginationSortMixin],
  /**
   * ---------------- Props ------------------
   */
  props: {
    data: { type: Array, required: true, default: () => [] },
    isLoading: { type: Boolean, required: true, default: false },
    defaultSortOrder: { type: String, required: true, default: "" },
  },
  /**
  |--------------------------------------------------
  | Data properties
  |--------------------------------------------------
  */
  data() {
    return {
      headers,
    };
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {},
};
</script>
